import { Scheme } from '../Flow/logic/types/GeneralTypes'
import { WizardComplete } from '../FlowsTemplates/types'
import { SelectOptionData } from '../Pi/types'

export type FlowsListConfig = {
	removeFlow: (flow_key: string) => Promise<void>
	getFlows: () => Promise<Array<{ key: string, title: string, link: string }>>
	getPreview: (key: string) => string
	exportFlowLink: (key: string) => string
	goToFlow: (key: string) => void
	boardAvatar: string
	createUtmLink: (utm: string, key: string) => Promise<string>
	importFlow: (flow_title: string, file: any) => Promise<void>
  createFlow: (flow_title: string, scheme: Scheme) => Promise<void>
  copyFlow: (flow_key: string, flow_title: string) => Promise <void>
  onFlowMastersButtonClick?: () => void
  importFlowTemplate: {
    // eslint-disable-next-line no-mixed-spaces-and-tabs
	  targetOptions: () => Array<SelectOptionData>
    onComplete: (data:WizardComplete) => Promise<void>
  }
}

export type FlowItem = {
  key: string
  title: string
  link: string
}

export enum AddNewFlowAction {
  Create,
  Copy,
  Import,
  ImportTemplate
}

